import PaymentsTable from "../../Payments/PaymentsTable";

const UserPayments = ({
    payments,
    onEdit,
    onDelete
}) => {
   
    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-sec-header"><h4>Payment History</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <PaymentsTable 
                    payments={payments}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            </div>
        </div> 
    );
};

export default UserPayments;
